<template>
    <Box title="" :SearchParams="IsSee" left-button="" @SearchParams="IsSee=true" ref='box'>
        <div class="message-content">
            <van-tabs swipeable background="rgba(0,0,0,0)" line-width="0" v-model="tabsIndex" swipeable animated>
                <van-tab title="消息">
                    <MessageList State="1" :startTime='startTime' :endTime="endTime" :action="tabsIndex === 0" :config="[
                        {id: 1, text:'待派工', img: require('../../assets/img/dpg.png'), color: '#48A4FF', router: 'Dispatch'},
                        {id: 3, text:'待验收', img: require('../../assets/img/dys.png'), color: '#48A4FF', router: 'ExamineReceive'},
                        {id: 6, text:'待接单', img: require('../../assets/img/djd.png'), color: '#48A4FF', router: 'OrderReceiving'},
                        {id: 8, text:'待审批', img: require('../../assets/img/dsp.png'), color: '#48A4FF', router: 'Examine'},

                        {id: 10, text:'保养实施', img: require('../../assets/img/JCI_maintain.png'), color: '#48A4FF', router: 'MaintainImplementDefault'},
                        {id: 11, text:'保养验收', img: require('../../assets/img/JCI_acceptance.png'), color: '#48A4FF', router: 'PrecautionreceivingDefault'},

                        {id: 12, text:'预防实施', img: require('../../assets/img/JCI_preventability.png'), color: '#48A4FF', router: 'QualityTest'},
                        {id: 13, text:'预防验收', img: require('../../assets/img/JCI_acceptance.png'), color: '#48A4FF', router: 'PrecautionreceivingDefault'},

                        {id: 14, text:'巡检实施', img: require('../../assets/img/JCI_polling.png'), color: '#48A4FF', router: 'PollingimplementDefault_XS'},
                        {id: 15, text:'巡检验收', img: require('../../assets/img/JCI_acceptance.png'), color: '#48A4FF', router: 'PrecautionreceivingDefault'},
                    ]" :inputValue="inputValue" />
                </van-tab>
                <van-tab title="待处理" @click='alert("")'>
                    <MessageList State="2" :startTime='startTime' :endTime="endTime" :action="tabsIndex === 1" :config="[
                        {id: 2, text:'待处理', img: require('../../assets/img/dwx.png'), color: '#009688', router: 'Pending'},
                        {id: 5, text:'处理中', img: require('../../assets/img/wxz.png'), color: '#009688', router: 'Pending'},
                    ]" :inputValue="inputValue" />
                </van-tab>
                <van-tab title="已完成">
                    <MessageList State="3" :startTime='startTime' :endTime="endTime" :action="tabsIndex === 2" :config="[
                        {id: 4, text:'已验收', img: require('../../assets/img/yys.png'), color: '#FF5722', router: 'ServiceDetails'},
                        {id: 7, text:'审批未通过', img: require('../../assets/img/yhl.png'), color: '#FF5722', router: 'ServiceDetails'},
                        {id: 9, text:'已忽略', img: require('../../assets/img/yhl.png'), color: '#FF5722', router: 'ServiceDetails'},
                        {id: 11, text:'保养记录', img: require('../../assets/img/JCI_maintain.png'), color: '#FF5722', router: 'MaintainImplementDefault'},
                        {id: 13, text:'预防记录', img: require('../../assets/img/JCI_preventability.png'), color: '#FF5722', router: 'QualityTest'},
                        {id: 15, text:'巡检记录', img: require('../../assets/img/JCI_polling.png'), color: '#FF5722', router: 'PollingimplementDefault_XS'},
                    ]" :inputValue="inputValue" />
                </van-tab>
            </van-tabs>
            <div class="calendar">
                <div @click="showCalendar=true;DateState=0;">
                    <p>开始日期</p>
                    <P :class="startTime ? 'black' : 'while'">{{startTime?startTime:'请选择'}}</P>
                </div>
                <div>
                    <div>{{Days}}天</div>
                </div>
                <div @click="showCalendar = true;DateState=1">
                    <p>结束日期</p>
                    <p :class="endTime ? 'black' : 'while'">{{endTime ? endTime : '请选择'}}</p>
                </div>
            </div>
            <van-calendar :min-date="minDate" :max-date="maxDate" v-model="showCalendar" @confirm="onConfirm" />
        </div>

        <transition name="fade">
            <div class="menu" v-if="IsSee">
                <div class="SearchInput">
                    <span>内容检索</span>
                    <van-search v-model="search.inputValue" placeholder="请输入搜索关键词" input-align="left"
                        @input='e=>search.inputValue=e' />
                </div>
                <div class="ChunkContent">
                    <span>快捷筛选</span>
                    <div :class="item.id==search.state?'Show':'Hidden'" v-for="(item,index) in ChunkList[tabsIndex].num"
                        @click.stop="item.id==search.state?search.state=null:search.state=item.id">{{item.name}}
                        <div v-if="search.state==item.id">
                            <img src="../../assets/img/correct.png" />
                        </div>
                    </div>
                </div>

                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import Field from '../../components/field/field.vue'
    import Box from '../../components/commonBox/commonBox'
    import {
        Calendar,
        Tab,
        Tabs,
        Search
    } from 'vant'
    import {
        MessageToPlanGetDefault,
        MessageToCheckAndAccept
    } from '../../../tool/api/api'
    import MessageList from '../../components/messageList/messageList'
    export default {
        name: 'message',
        data() {
            return {
                minDate: new Date('2010-01-01'.replace(/-/g, "/")), //日历区间最小日期
                maxDate: new Date(), //日历区间最大日期
                startTime: this.$format(new Date().setMonth(new Date().getMonth() - 1), 'YYYY-MM-DD'),//开始时间
                endTime: this.$format(new Date(), 'YYYY-MM-DD'),//结束时间,
                DateState: 0, //时间状态   0 开始时间的确认，1结束时间的确认
                tabsIndex: this.$store.getters.tabsIndex,
                showCalendar: false, //    是否显示日历
                inputValue: null,
                Days: 0, //相差天数
                IsSee: false,
                search: { //搜索条件
                    inputValue: null,
                    state: null,
                },
                ChunkList: [{
                    num: [{
                        id: 1,
                        name: '待派工'
                    }, {
                        id: 3,
                        name: '待验收'
                    }, {
                        id: 6,
                        name: '待接单'
                    }, {
                        id: 8,
                        name: '待审批'
                    }, {
                        id: 10,
                        name: '保养实施'
                    }, {
                        id: 11,
                        name: '保养验收'
                    }, {
                        id: 12,
                        name: '预防实施'
                    }, {
                        id: 13,
                        name: '预防验收'
                    }, {
                        id: 14,
                        name: '巡检实施'
                    }, {
                        id: 15,
                        name: '巡检验收'
                    }]
                }, {
                    num: [{
                        id: 2,
                        name: '待处理'
                    }, {
                        id: 5,
                        name: '处理中'
                    }]
                }, {
                    num: [{
                        id: 4,
                        name: '已验收'
                    }, {
                        id: 7,
                        name: '审批未通过'
                    }, {
                        id: 9,
                        name: '已忽略',
                    }, {
                        id: 11,
                        name: '保养记录'
                    }, {
                        id: 13,
                        name: '预防记录'
                    }, {
                        id: 15,
                        name: '巡检记录'
                    }]
                }]
            }
        },
        components: {
            Box,
            MessageList,
            Field,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Search.name]: Search,
            [Calendar.name]: Calendar
        },
        watch: {
            tabsIndex(newValue, oldValue) {
                this.search.state = null;
                window.scrollTo(0, 0);
                this.$store.commit('SET_TABS_INDEX', newValue)
                this.inputValue = null //清空搜索内容
                this.$refs.box._hiddenInput()
            },
            $route(to, form) {
                if (to.name === 'OrderReceiving') { //待接单
                    to.params.hiddenTitle = true; //附加一个属性
                }
            },startTime(newvalue, oldvalue) {
                if (newvalue === '' || this.endTime === '') {
                    this.Days = 0;
                    return;
                }
                this.Days = parseInt((new Date(this.endTime).getTime() - new Date(this.startTime).getTime()) /
                    86400000);
            },
            endTime(newvalue, oldvalue) {
                if (newvalue === '' || this.startTime === '') {
                    this.Days = 0;
                    return;
                }
                this.Days = parseInt((new Date(this.endTime).getTime() - new Date(this.startTime).getTime()) /
                    86400000);
            },
        },
        beforeDestroy() {
            this.$Bus.$off(['selectAccessories', 'selectStaff', 'YSRKDelete', 'hiddenEvent'])
        },
        mounted() {
            this.$Bus.$on('IsSee', (res) => {
                this.IsSee = res;
            })

            this.$router.beforeEach((to, from, next) => { //(阻止跳转)  添加参数
                if (to.name === 'ExamineReceive' && !to.params.state && from.name === 'Message') { //待验收
                    this.$post('api/Dispatch/DispatchList', {
                        RepairStatus: '9',
                        EquCode: '',
                        RepairOrder: to.params.item.OrderNo,
                        DepartmentId: '',
                        UserCode: this.$UserInfo.UserId,
                        Store: this.$UserInfo.StoreCode,
                        SortType: '',
                        AssignOrConfirm: '1',
                        StartDate: '',
                        EndDate: '',
                        PageIndex: 1,
                        PageSize: 1,
                        Token: '123456'
                    }).then(result => {
                        //to.params.item.OrderNo
                        if (!!result.DispatchList && result.DispatchList.length === 1) {
                            this.$router.push({
                                name: 'ExamineReceive',
                                params: {
                                    item: result.DispatchList[0],
                                    state: true
                                }
                            });
                        } else this.$Toast('数据异常,请联系管理员!');
                    });
                    return false; //此false阻止route跳转
                } else if (to.name === 'Pending' && !to.params.state && from.name ===
                    'Message') { //待处理/处理中（阻止跳转）
                    let that = this;
                    that.$axios.all([that.$post('api/Dispatch/DispatchList', {
                        RepairStatus: '6',
                        EquCode: '',
                        RepairOrder: to.params.item.OrderNo,
                        DepartmentId: '',
                        UserCode: that.$UserInfo.UserId,
                        Store: that.$UserInfo.StoreCode,
                        SortType: '',
                        AssignOrConfirm: '1',
                        StartDate: '',
                        EndDate: '',
                        PageIndex: 1,
                        PageSize: 1,
                        Token: '123456'
                    }), that.$get('api/Repair/MaintenanceOther', {
                        WXDH: to.params.item.OrderNo,
                        JCHH: '1'
                    })]).then(that.$axios.spread(function(res, rel) {
                        let item = {};
                        if (res.DispatchList && res.DispatchList.length === 1) { //维修基本信息
                            item = res.DispatchList[0]
                        }
                        let ImageArray = []; //图片集合
                        let ProcessDefault = {
                            RepairMark: '',
                            AccessoriesMoney: 0,
                            MaintainMoney: 0,
                            RepairTypeName: "自修",
                            RepairType: '',
                            WXGS: 0,
                            TotalMoney: 0
                        }

                        if (rel.ProcessDefault.length > 0) {
                            let data = rel.ProcessDefault[0];
                            ProcessDefault.RepairMark = data.RepairMark;
                            ProcessDefault.AccessoriesMoney = data.AccessoriesMoney ? data
                                .AccessoriesMoney :
                                0;
                            ProcessDefault.MaintainMoney = data.MaintainMoney ? data.MaintainMoney :
                                0; //维修费用
                            ProcessDefault.RepairTypeName = data.RepairTypeName;
                            ProcessDefault.RepairType = data.RepairType;
                            ProcessDefault.WXGS = data.WXGS ? data.WXGS : 0;
                            ProcessDefault.TotalMoney = ProcessDefault.AccessoriesMoney +
                                ProcessDefault.MaintainMoney;
                        };

                        //图片处理
                        rel.accessory.forEach(function(item, index) {
                            ImageArray.push({
                                HH: item.HH,
                                url: item.Repath,
                                Repath: item.WJLJ
                            });
                        })

                        that.skip(item, ProcessDefault, ImageArray, false).then(res => {
                            that.$Bus.$emit('selectAccessories', rel.accessories); //配件
                            that.$Bus.$emit('selectStaff', rel.serviceman); //人员
                            that.$Bus.$emit('YSRKDelete', ImageArray); //图片
                        })
                    })).catch(err => {
                        that.$Toast('系统异常,请联系管理员!');
                    })
                    return false;
                } else if (to.name === 'ServiceDetails' && !to.params.state && from.name ===
                    'Message') { //已完成 （阻止跳转）继续跳转维修处理页面
                    let that = this;
                    that.$axios.all([that.$post('api/Dispatch/DispatchList', {
                        RepairStatus: '10',
                        EquCode: '',
                        RepairOrder: to.params.item.OrderNo,
                        DepartmentId: '',
                        UserCode: that.$UserInfo.UserId,
                        Store: that.$UserInfo.StoreCode,
                        SortType: '',
                        AssignOrConfirm: '1',
                        StartDate: '',
                        EndDate: '',
                        PageIndex: 1,
                        PageSize: 1,
                        Token: '123456'
                    }), that.$get('api/Repair/MaintenanceOther', {
                        WXDH: to.params.item.OrderNo,
                        JCHH: '1'
                    })]).then(that.$axios.spread(function(res, rel) {
                        let item = {};
                        if (res.DispatchList && res.DispatchList.length === 1) { //维修基本信息
                            item = res.DispatchList[0]
                        }
                        let ImageArray = []; //图片集合
                        let ProcessDefault = {
                            RepairMark: '',
                            AccessoriesMoney: 0,
                            MaintainMoney: 0,
                            RepairTypeName: "自修",
                            RepairType: '',
                            WXGS: 0,
                            TotalMoney: 0
                        }

                        if (rel.ProcessDefault.length > 0) {
                            let data = rel.ProcessDefault[0];
                            ProcessDefault.RepairMark = data.RepairMark;
                            ProcessDefault.AccessoriesMoney = data.AccessoriesMoney ? data
                                .AccessoriesMoney :
                                0;
                            ProcessDefault.MaintainMoney = data.MaintainMoney ? data.MaintainMoney :
                                0; //维修费用
                            ProcessDefault.RepairTypeName = data.RepairTypeName;
                            ProcessDefault.RepairType = data.RepairType;
                            ProcessDefault.WXGS = data.WXGS ? data.WXGS : 0;
                            ProcessDefault.TotalMoney = ProcessDefault.AccessoriesMoney +
                                ProcessDefault.MaintainMoney;
                        };

                        //图片处理
                        rel.accessory.forEach(function(item, index) {
                            ImageArray.push({
                                HH: item.HH,
                                url: item.Repath,
                                Repath: item.WJLJ
                            });
                        })

                        that.skip(item, ProcessDefault, ImageArray, true).then(res => {
                            that.$Bus.$emit('selectAccessories', rel.accessories); //配件
                            that.$Bus.$emit('selectStaff', rel.serviceman); //人员
                            that.$Bus.$emit('YSRKDelete', ImageArray); //图片
                        })
                    })).catch(err => {
                        that.$Toast('系统异常,请联系管理员!');
                    })
                    return false;
                } else if ((to.name === 'MaintainImplementDefault' || to.name === 'QualityTest' || to.name ===
                        'PollingimplementDefault_XS') && !to.params.state && from.name === 'Message') {
                    MessageToPlanGetDefault(to.name === 'MaintainImplementDefault' ? '1' : to.name ===
                        'QualityTest' ? '2' : '3',
                        to.params.item.OrderNo, to.params.item.EquId, this.tabsIndex)
                    return false;
                } else if (to.name === 'PrecautionreceivingDefault' && !to.params.state && from.name ===
                    'Message') {
                    MessageToCheckAndAccept(to.params.item.State, to.params.item.OrderNo, to.params.item.EquId);
                    return false;
                } else if (to.name === 'Examine' && !to.params.state && from.name === 'Message') {
                    this.tabsIndex == 0 ? to.params.ExistsButton = true : '';
                }
                return next();
            })
        },
        methods: {
            serach() {
                this.$Bus.$emit('hiddenEvent', this.search);
                this.IsSee = false;
            },
            skip(item, ProcessDefault, ImageArray, ButtonExists) {
                return new Promise((resolve, reject) => {
                    this.$router.push({
                        name: 'Pending',
                        params: {
                            item,
                            ProcessDefault,
                            ImageArray,
                            state: true,
                            ButtonExists: !!ButtonExists //隐藏按钮
                        }
                    });
                    resolve();
                })
            },
            onConfirm(data) {
                data = this.$format(data, 'YYYY-MM-DD');
                this.DateState === 0 ? this.startTime = data : this.endTime = data;
                this.showCalendar=false;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .Hidden {
        background: #F6F6F6;
        color: #2E2E2E;
    }

    .Show {
        background: #EEF7FE;
        color: #2F7BE4;
    }

    .SearchInput {
        margin-top: 5vw;

        span {
            display: block;
            font-size: 3vw;
            color: #7F7F7F;
        }
    }

    .ChunkContent {
        span {
            display: block;
            font-size: 3vw;
            color: #7F7F7F;
        }

        &>div {
            position: relative;
            width: 20%;
            margin: 3vw 2%;
            display: inline-block;
            font-size: 2.5vw;

            text-align: center;
            height: 6vw;
            padding-top: 2vw;

            &>div {
                position: absolute;
                bottom: 0;
                right: 0;
                border-style: solid;
                width: 0px;
                height: 0px;
                border-width: 0px 0px 3vw 3vw;
                border-color: transparent transparent #2972E2 transparent;

                img {
                    position: absolute;
                    bottom: -3vw;
                    right: 0;
                    width: 2vw;
                    height: 2vw;
                }
            }
        }
    }

    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-top: 12vw;
        margin-bottom: 20px;
        transition: all .5s;

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }


    .message-content {
        width: 710px;
        margin: auto;
        padding-top: 95px;
        padding-bottom: 50px;
    }

    .calendar {
        display: flex;
        height: 166px;
        border-radius: 16px;
        background: $BACKGROUND-COLOR;
        align-items: center;
        padding: 0 50px 0 36px;
        box-sizing: border-box;
        position: absolute;
        top:31vw;
        width: 100%;

        &>div {
            flex: 1;
            position: relative;

            p {
                &:first-child {
                    font-size: 28px;
                    color: #4A4A4A;
                }

                &:last-child {
                    font-size: 32px;
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    margin-top: 12px;
                }
            }

            &:first-child {
                text-align: left;
            }

            &:nth-child(2) {
                text-align: center;

                div {
                    &:first-child {
                        width: 100%;
                        background: #F4F4F4;
                        height: 2px;
                    }

                    &:last-child {
                        position: absolute;
                        width: 86px;
                        height: 32px;
                        border-radius: 20px;
                        background: $BACKGROUND-COLOR;
                        border: 2px solid #F4F4F4;
                        color: #969799;
                        font-size: 20px;
                        text-align: center;
                        line-height: 32px;
                        left: 0;
                        right: 0;
                        margin: auto;
                        top: 0;
                        bottom: 0;
                    }
                }
            }

            &:last-child {
                text-align: right;
            }
        }

        .black {
            font-size: 32px !important;
            color: $TEXT-DARK-COLOR !important;
            font-weight: bold !important;
        }

        .while {
            font-size: 28px !important;
            color: #969799 !important;
            font-weight: 400 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/message/message.vue